export const getCurrentSubscriptionQuery = async () =>
    fetch('/api/v2/accounts/subscription/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
